import request from '@/utils/request'

// 绑定用户ID到WebSocket连接
export function bindUidToWebSocket(data) {
  return request.post('/v1/ws/bind', data)
}

// 收藏游戏接口
export function gameFavoriteApi(data) {
  return request.post('/game/favorite', data)
}
// export function gameFavoriteApi(data) {
//   return request.post('/game/favorite', data, {
//     headers: {
//       'Content-Type': 'multipart/form-data',
//     },
//   })
// }
// 获取游戏链接接口
export function gameUrlApi(params) {
  return request.get('/game/lunchUrl', { params })
}
